
<loading class="pos-fix vh-center" *ngIf="loading"></loading>
@if (!isRegimenOrder) {
<div class="tw-h-full tw-bg-gray-100 tw-font-body tw-overflow-auto" *ngIf="!loading && order">
  <!-- ===== HEADER ===== -->
  <div class="tw-px-4 tw-pt-4 tw-pb-3.5" [ngClass]="orderCanceledStages.includes(order?.stage ) ? 'tw-bg-orange-100' : 'tw-bg-teal-100'">
    <!-- Nav bar: back + cart -->
    <div class="tw-flex tw-justify-between tw-items-center">
      <cs-icon class="tw-h-6 tw-w-6" [iconName]="'arrow_back'" (click)="back()"></cs-icon>
      <div *ngIf="!isBlockedForUnpaidAcquisitionProduct()" class="tw-relative" (click)="navigateToCart()">
        <cs-icon class="tw-h-6 tw-w-6" [iconName]="'shopping_cart'"></cs-icon>
        <span *ngIf="numberOfProductsInCart" class="tw-absolute tw--top-1 tw--right-1 tw-bg-red-400 tw-text-white tw-rounded-full tw-h-4 tw-w-4 tw-flex tw-items-center tw-justify-center tw-text-100 tw-font-bold">{{numberOfProductsInCart}}</span>
      </div>
    </div>
    <!-- Title row -->
    <div class="tw-flex tw-justify-between tw-items-start tw-mt-8">
      <div class="tw-flex tw-flex-col" [ngClass]="orderDeliveredStages.includes(order?.stage ) ? 'tw-gap-1.5' : 'tw-gap-3'">
        <ng-container [ngSwitch]="true">
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourPaymentIsPending" *ngSwitchCase="orderPaymentPendingStages.includes(order.stage )"> Your payment is pending </p>
          <ng-container *ngSwitchCase="orderDeliveredStages.includes(order.stage )">
            <p class="tw-text-400 tw-font-bold tw-text-black" *ngIf="!shouldShowPartialOrderCancellationUI">
              {{order?.productInfo ?.length}} <span *ngIf="order?.productInfo ?.length === 1" i18n="@@newUIProductDelivered">product delivered</span><span *ngIf="order?.productInfo ?.length !== 1" i18n="@@newUIProductsDelivered">products delivered</span>
            </p>
            <p class="tw-text-400 tw-font-bold tw-text-black" *ngIf="shouldShowPartialOrderCancellationUI">
              {{order?.productInfo ?.length}}/{{order?.productInfo ?.length + (cancelledProducts?.length || 0)}} <span *ngIf="order?.productInfo ?.length === 1" i18n="@@newUIProductDelivered">product delivered</span><span *ngIf="order?.productInfo ?.length !== 1" i18n="@@newUIProductsDelivered">products delivered</span>
            </p>
          </ng-container>
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourOrderIsPlaced" *ngSwitchCase="orderPlacedStages.includes(order.stage ) || order.stage  === STAGE.INVOICE_REQUESTED"> Your order is placed </p>
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourOrderIsPacked" *ngSwitchCase="orderPackedStages.includes(order.stage )"> Your order is packed </p>
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourOrderIsDispatched" *ngSwitchCase="orderDispatchedStages.includes(order.stage )"> Your order is dispatched </p>
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@deliveryAttemptFailed" *ngSwitchCase="orderDeliveryFailedStages.includes(order.stage )"> Delivery attempt failed </p>
          <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@orderOutForDelivery" *ngSwitchCase="orderOutForDeliveryStages.includes(order.stage )"> Your order is out for delivery </p>
          <div *ngSwitchCase="orderCanceledStages.includes(order.stage )">
            @if (isOrderInRefundRelatedStages) {
              @switch (latestOrderLog?.stage) {
                @case (STAGE.REFUND_REQUESTED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourRefundIsInProcess">Your refund is in process</p>
                }
                @case (STAGE.REFUND_INITIATED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourRefundHasBeenInitiated">Your refund has been initiated</p>
                }
                @case (STAGE.REFUND_PROCESSED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourRefundHasBeenProcessedOn">Your refund has been processed on {{refundProcessedDate | date: 'd MMM'}}</p>
                }
              }
            } @else {
              @switch (order.stage) {
                @case (STAGE.RETURN_REQUESTED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourReturnRequestIsInProcess">Your return request is in process</p>
                }
                @case (STAGE.RETURN_INITIATED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourReturnHasBeenInitiated">Your return has been initiated</p>
                }
                @case (STAGE.RETURNED) {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourOrderIsReturned">Your order is returned</p>
                }
                @default {
                  <p class="tw-text-400 tw-font-bold tw-text-black" i18n="@@yourOrderIsCancelled">Your order is Cancelled</p>
                }
              }
            }
          </div>
          <p class="tw-text-400 tw-font-bold tw-text-black" *ngIf="order.stage  === STAGE.CANCEL_REQUESTED" i18n="@@cancellationRequestInitiated">A cancellation request has been initiated for this order. Click the "Cancel Order" button below to confirm</p>
        </ng-container>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <p *ngIf="orderNumber" class="tw-text-200 tw-font-medium" [ngClass]="orderDeliveredStages.includes(order.stage ) ? 'tw-text-gray-500' : 'tw-text-black'">
            <span i18n="@@orderNo">Order no:</span> #{{orderNumber}}
          </p>
          @if (expectedDeliveryDate.from && expectedDeliveryDate.to && !orderCanceledStages.includes(order.stage ) && !orderDeliveredStages.includes(order.stage )) {
            <p class="tw-text-200 tw-font-medium tw-text-gray-800">
              <span i18n="@@expectedDeliveryDate"> Expected Delivery Date </span><br/>
              {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
            </p>
          }
        </div>
      </div>
      <!-- Right side action buttons -->
      <ng-container [ngSwitch]="true">
        <div class="tw-self-center tw-shrink-0">
          <span (click)="makePaymentForOrder()"
            class="tw-shrink-0 tw-py-2 tw-px-4 tw-bg-teal-600 tw-text-white tw-text-300 tw-font-semibold tw-rounded-2"
            i18n="@@makePayment"
            *ngSwitchCase="orderPaymentPendingStages.includes(order.stage )">
            Make payment
          </span>
          <div *ngSwitchCase="orderPlacedStages.includes(order?.stage ) ||
            orderPackedStages.includes(order?.stage ) ||
            orderDispatchedStages.includes(order?.stage ) ||
            orderDeliveryFailedStages.includes(order?.stage ) ||
            orderOutForDeliveryStages.includes(order?.stage )">
            <span *ngIf="order?.trackingId "
              (click)='trackOrder(order.trackingURL )'
              class="tw-shrink-0 tw-py-2 tw-px-4 tw-bg-teal-600 tw-text-white tw-text-300 tw-font-semibold tw-rounded-2"
              i18n="@@trackOrder">Track Order</span>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- Know How to use button (delivered states only) -->
    <div *ngIf="orderDeliveredStages.includes(order?.stage )"
      class="tw-mt-3 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-pl-4 tw-pr-2 tw-bg-teal-600 tw-rounded-2 tw-overflow-hidden tw-relative"
      (click)="handleKnowHowToUse()">
      <span *ngIf="isRegimenOrder" class="tw-text-400 tw-font-semibold tw-text-white" i18n="@@knowHowToUse">Know How to use</span>
      <span *ngIf="!isRegimenOrder" class="tw-text-400 tw-font-semibold tw-text-white tw-font-lexend" i18n="@@knowHowToUse">Know How to use</span>
      <cs-icon class="tw-h-5 tw-w-5 tw-text-white" [iconName]="'chevron_right_current'"></cs-icon>
    </div>
  </div>

  <!-- ===== CONTENT SECTIONS ===== -->
  <div class="tw-flex tw-flex-col tw-gap-3 tw-pt-3">

    <!-- Delivery Address BEFORE products (for transit/active states) -->
    <div class="ld-session-block tw-p-4 tw-bg-white"
      *ngIf="!orderDeliveredStages.includes(order?.stage ) && !orderCanceledStages.includes(order?.stage )">
      <p class="tw-text-300 tw-font-bold tw-text-black" i18n="@@deliveryAddress">Delivery Address</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">{{order.contactDetail.contactName}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">{{order.contactDetail.buildingDetails}}, {{$any(order.contactDetail)?.localityDetails}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">
        <span *ngIf="$any(order.contactDetail)?.landmark">{{$any(order.contactDetail).landmark}}, </span>
        <span *ngIf="order.contactDetail?.city">{{order.contactDetail.city}}, </span>
        <span *ngIf="order.contactDetail?.state">{{order.contactDetail.state}}, </span>
        <span *ngIf="order.contactDetail?.zipCode">{{order.contactDetail.zipCode}}</span>
      </p>
      <p *ngIf="!internalUser" class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">+91 {{order.contactDetail.contactNumber}}</p>
    </div>

    <!-- Important Update section (partial cancellation) -->
    @if (shouldShowPartialOrderCancellationUI && cancelledProducts?.length) {
      <div class="tw-bg-gradient-orange-to-white tw-p-4">
        <div class="tw-flex tw-items-center tw-gap-1">
          <cs-icon class="tw-w-4 tw-h-4" [iconName]="'exclamation_orange'"></cs-icon>
          <p class="tw-uppercase tw-text-200 tw-font-bold tw-font-body tw-text-orange-500 tw-tracking-widest" i18n="@@importantUpdate">Important Update</p>
        </div>
        <div class="tw-mt-6 tw-flex tw-flex-col tw-gap-2">
          <div class="tw-text-300 tw-font-medium tw-font-body tw-text-black">
            <p i18n="@@followingProductsRemovedByDoctor">Following products are removed by your doctor</p>
            <div class="tw-mt-2.5">
              @for (product of cancelledProducts; track product?.productObjectId) {
                <p>&#8226; {{product?.title}}</p>
              }
            </div>
          </div>
          <c-audio [newUI]="true" [imageUrl]="doctorImageUrl" [src]="productApprovalDetails?.signedUrlForRejectedVoiceNote || productApprovalDetails?.signedUrlForVoiceNoteURL"></c-audio>
        </div>
      </div>
    }

    <!-- ===== PRODUCTS SECTION ===== -->
    <div class="tw-px-4 tw-flex tw-flex-col tw-gap-3">
      <p *ngIf="!orderDeliveredStages.includes(order?.stage )" class="tw-text-300 tw-font-normal tw-text-black">
        {{order?.productInfo ?.length || 0}} <span *ngIf="order?.productInfo ?.length === 1" i18n="@@productInYourOrder">Product in your order</span><span *ngIf="order?.productInfo ?.length !== 1" i18n="@@productsInYourOrder">Products in your order</span>
      </p>

      <!-- Active Product Cards -->
      @for (product of order?.productInfo ; track product.id) {
        @if (!shouldShowPartialOrderCancellationUI || !isCancelledProduct(product)) {
          <div class="tw-rounded-2 tw-bg-white" [ngClass]="isRegimenOrder ? 'tw-p-4' : 'tw-px-4 tw-py-4.5'" (click)="handleProductCardClick(product)">
            <div class="tw-flex tw-gap-4">
              <div class="tw-overflow-hidden" [ngClass]="isRegimenOrder ? 'tw-w-20 tw-min-w-20 tw-rounded-md tw-bg-teal-200' : 'tw-w-[83px] tw-min-w-[83px] tw-h-[104px] tw-rounded-1.5 tw-bg-teal-200'">
                <img #productImg [src]="products[product.id]?.rebrandedImageWithBackground?.[0]" class="tw-w-full tw-h-auto tw-object-cover" [ngClass]="isRegimenOrder ? 'tw-rounded-md' : 'tw-h-full tw-rounded-1.5'" alt="product"/>
              </div>
              <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0" [ngClass]="!isRegimenOrder ? 'tw-justify-between' : 'tw-gap-4'">
                <div class="tw-flex tw-flex-col tw-gap-0.5">
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <span *ngIf="isRegimenOrder" class="tw-text-200 tw-font-normal tw-text-gray-500">Qty {{product?.quantity}}</span>
                    <span *ngIf="!isRegimenOrder" class="tw-text-200 tw-font-normal tw-text-gray-500">{{getProductSizeLabel(product.id)}}{{product?.quantity > 1 ? ' x ' + product?.quantity : ''}}</span>
                    <span class="tw-text-200 tw-font-normal tw-shrink-0">
                      @if (product?.SP > 0) {
                        <span class="tw-line-through tw-text-gray-400">₹{{product?.MRP}}</span>&nbsp;<span class="tw-text-black tw-font-bold">₹{{product?.SP}}</span>
                      } @else {
                        <span class="tw-line-through tw-text-gray-400">₹{{product?.MRP}}</span>&nbsp;<span class="tw-text-teal-500 tw-font-bold tw-uppercase" i18n="@@free">free</span>
                      }
                    </span>
                  </div>
                  <p class="tw-text-300 tw-font-bold tw-text-black">{{product?.name}}</p>
                </div>
                @if (canReorderProduct(product)) {
                  <span class=" tw-py-2 tw-px-4 tw-border tw-border-solid tw-border-teal-600 tw-rounded-2 tw-text-300 tw-font-semibold tw-text-teal-600 tw-h-8 tw-w-[106px] tw-flex tw-items-center tw-justify-center tw-font-lexend tw-overflow-hidden"
                    (click)="reorder(product, productImg); $event.stopPropagation()" i18n="@@reorder">Reorder</span>
                } @else if (canViewProduct(product)) {
                  <span class="tw-py-2 tw-px-4 tw-border tw-border-solid tw-border-teal-600 tw-rounded-2 tw-text-300 tw-font-semibold tw-text-teal-600 tw-capitalize tw-h-8 tw-w-[133px] tw-flex tw-items-center tw-justify-center tw-font-lexend tw-gap-2"
                    (click)="handleNavigation(product); $event.stopPropagation()" i18n="@@viewProduct">view product</span>
                }
              </div>
            </div>
          </div>
        }
      }

      <!-- Cancelled Product Cards (partial cancellation) -->
      @if (shouldShowPartialOrderCancellationUI && cancelledProducts?.length) {
        @for (product of cancelledProducts; track product?.productObjectId) {
          <div class="tw-rounded-2 tw-bg-white" [ngClass]="isRegimenOrder ? 'tw-p-4 tw-opacity-40' : 'tw-px-4 tw-py-4.5'">
            <div class="tw-flex tw-gap-4">
              <div class="tw-overflow-hidden" [ngClass]="isRegimenOrder ? 'tw-w-20 tw-min-w-20 tw-rounded-md tw-bg-teal-200' : 'tw-w-[83px] tw-min-w-[83px] tw-h-[104px] tw-rounded-1.5 tw-bg-teal-200 tw-opacity-30'">
                <img [src]="product?.imageUrl" class="tw-w-full tw-h-auto tw-object-cover" [ngClass]="isRegimenOrder ? 'tw-rounded-md' : 'tw-h-full tw-rounded-1.5'" alt="cancelledProduct"/>
              </div>
              <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0" [ngClass]="isRegimenOrder ? 'tw-gap-4' : 'tw-justify-between tw-h-[104px]'">
                <div class="tw-flex tw-flex-col tw-gap-0.5" [ngClass]="!isRegimenOrder ? 'tw-opacity-30' : ''">
                  <div class="tw-flex tw-justify-between">
                    <span class="tw-text-200 tw-font-normal tw-text-gray-500">
                      <ng-container *ngIf="isRegimenOrder">Qty {{product?.quantity}}</ng-container>
                      <ng-container *ngIf="!isRegimenOrder">{{getProductSizeLabel(product?.productObjectId)}}{{product?.quantity > 1 ? ' x ' + product?.quantity : ''}}</ng-container>
                    </span>
                    <span class="tw-text-200 tw-font-normal tw-shrink-0">
                      <span class="tw-line-through tw-text-gray-400">₹{{product?.mrp}}</span>&nbsp;<span class="tw-text-black tw-font-bold">₹{{product?.price}}</span>
                    </span>
                  </div>
                  <p class="tw-text-300 tw-font-bold tw-text-black">{{product?.title}}</p>
                </div>
                <!-- Cancel label for regimen -->
                <div *ngIf="isRegimenOrder" class="tw-py-1 tw-px-3 tw-bg-orange-100 tw-rounded-1 tw-w-fit">
                  <span class="tw-text-200 tw-font-medium tw-text-orange-400" i18n="@@cancelledRemovedByDoctor">Cancelled: Removed by doctor</span>
                </div>
                <!-- Cancel label for non-regimen -->
                <div *ngIf="!isRegimenOrder" class="tw-py-1 tw-px-3 tw-bg-gray-100 tw-rounded-1 tw-w-fit tw-whitespace-nowrap">
                  <span class="tw-text-200"><span class="tw-font-bold tw-text-orange-400 tw-mr-1" i18n="@@cancelledColon">Cancelled:</span><span class="tw-font-normal tw-text-black" i18n="@@removedByDoctorText"> Removed by doctor</span></span>
                </div>
              </div>
            </div>
          </div>
        }
      }
      @if (isOnlinePayment && refundInfo?.latestRefundDate) {
        <p class="tw-text-200 tw-py-3 tw-px-2 tw-flex tw-justify-center tw-items-center tw-bg-orange-100 tw-rounded-2.5 tw-shadow-z13" i18n="@@refundCompletedOn">
          <span class="tw-font-[700] tw-mx-1">Refund Completed: ₹{{refundInfo.totalRefundAmount}}</span> on {{refundInfo.latestRefundDate | date:'dd MMM yyyy'}}
        </p>
      }
    </div>

    <!-- Delivery Address AFTER products, BEFORE CTAs (cancelled states) -->
    <div class="ld-session-block tw-p-4 tw-bg-white"
      *ngIf="orderCanceledStages.includes(order?.stage )">
      <p class="tw-text-300 tw-font-bold tw-text-black" i18n="@@deliveryAddress">Delivery Address</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">{{order.contactDetail.contactName}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">{{order.contactDetail.buildingDetails}}, {{$any(order.contactDetail)?.localityDetails}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">
        <span *ngIf="$any(order.contactDetail)?.landmark">{{$any(order.contactDetail).landmark}}, </span>
        <span *ngIf="order.contactDetail?.city">{{order.contactDetail.city}}, </span>
        <span *ngIf="order.contactDetail?.state">{{order.contactDetail.state}}, </span>
        <span *ngIf="order.contactDetail?.zipCode">{{order.contactDetail.zipCode}}</span>
      </p>
      <p *ngIf="!internalUser" class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">+91 {{order.contactDetail.contactNumber}}</p>
    </div>

    <!-- ===== CTAs SECTION ===== -->
    <div class="tw-px-4">
      <div class="tw-bg-white tw-flex tw-flex-col" [ngClass]="isRegimenOrder ? 'tw-py-4 tw-px-4 tw-rounded-2 tw-gap-3' : 'tw-py-5 tw-px-3.5 tw-rounded-2.5 tw-gap-3.5 tw-shadow-z4'">
        <div *ngIf='$any(order).signedUrlForPdfInvoice' class="tw-flex tw-items-center tw-justify-between" (click)='openInvoiceUrl($any(order).signedUrlForPdfInvoice)'>
          <p class="tw-font-bold tw-text-black" [ngClass]="isRegimenOrder ? 'tw-text-300' : 'tw-text-200'" i18n="@@downloadInvoice"> Download Invoice </p>
          <cs-icon [ngClass]="isRegimenOrder ? 'tw-h-4 tw-w-4' : 'tw-h-3.5 tw-w-2'" [iconName]="'chevron_right_green'"></cs-icon>
        </div>
        <div *ngIf='$any(order).signedUrlForPdfInvoice' class="tw-border-b tw-border-gray-200"></div>
        <div class="tw-flex tw-items-center tw-justify-between" routerLink="/support">
          <p class="tw-font-bold tw-text-black" [ngClass]="isRegimenOrder ? 'tw-text-300' : 'tw-text-200'">
            <span i18n="@@needHelp">Need help</span><span>?</span>
          </p>
          <cs-icon [ngClass]="isRegimenOrder ? 'tw-h-4 tw-w-4' : 'tw-h-3.5 tw-w-2'" [iconName]="'chevron_right_green'"></cs-icon>
        </div>
        @if (cancelOrderAllowed) {
          <div class="tw-border-b tw-border-gray-200"></div>
          <div class="tw-flex tw-items-center tw-justify-between" (click)="cancelOrderDialog()">
            <p class="tw-text-200 tw-font-bold tw-text-orange-400" i18n="@@cancelOrder">Cancel Order</p>
            <cs-icon [ngClass]="isRegimenOrder ? 'tw-h-4 tw-w-4 tw-text-orange-400' : 'tw-h-3.5 tw-w-2 tw-text-orange-400'" [iconName]="'chevron_right'"></cs-icon>
          </div>
        }
      </div>
    </div>

    <!-- Delivery Address AFTER CTAs (delivered states) -->
    <div class="ld-session-block tw-p-4 tw-bg-white" [ngClass]="!isRegimenOrder ? 'tw-mt-3' : ''"
      *ngIf="orderDeliveredStages.includes(order?.stage )">
      <p class="tw-text-300 tw-font-bold tw-text-black" i18n="@@deliveryAddress">Delivery Address</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">{{order.contactDetail.contactName}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">{{order.contactDetail.buildingDetails}}, {{$any(order.contactDetail)?.localityDetails}}</p>
      <p class="tw-text-gray-400 tw-text-300 tw-font-normal">
        <span *ngIf="$any(order.contactDetail)?.landmark">{{$any(order.contactDetail).landmark}}, </span>
        <span *ngIf="order.contactDetail?.city">{{order.contactDetail.city}}, </span>
        <span *ngIf="order.contactDetail?.state">{{order.contactDetail.state}}, </span>
        <span *ngIf="order.contactDetail?.zipCode">{{order.contactDetail.zipCode}}</span>
      </p>
      <p *ngIf="!internalUser" class="tw-text-gray-400 tw-text-300 tw-font-normal tw-mt-1.5">+91 {{order.contactDetail.contactNumber}}</p>
    </div>

    <!-- ===== PAYMENT DETAILS ===== -->
    <div class="tw-flex tw-flex-col tw-bg-white tw-pt-4 tw-gap-2" [ngClass]="!isRegimenOrder ? 'tw-mt-3' : ''">
      <h2 class="tw-font-body tw-font-bold tw-text-300 tw-px-4" [ngClass]="isRegimenOrder ? 'tw-mb-2' : 'tw-mb-1'" i18n="@@paymentDetails"> Payment details </h2>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200" [ngClass]="isRegimenOrder ? 'tw-text-gray-800' : 'tw-text-gray-500'" i18n="@@paymentMethod">Payment method</span>
        <span class="tw-font-body tw-text-200">{{order.paymentType.replace('_', ' ') | titlecase}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200" [ngClass]="isRegimenOrder ? 'tw-text-gray-800' : 'tw-text-gray-500'" i18n="@@subtotalInclusiveTax">Subtotal (inclusive tax)</span>
        <span class="tw-font-body tw-text-200">₹{{orderMRP}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200" [ngClass]="isRegimenOrder ? 'tw-text-gray-800' : 'tw-text-gray-500'" i18n="@@discount">Discount</span>
        <span class="tw-font-body tw-text-200 tw-text-orange-400">(-) ₹{{+orderMRP - +orderSp}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200" [ngClass]="isRegimenOrder ? 'tw-text-gray-800' : 'tw-text-gray-500'" i18n="@@shippingCharges">Shipping charges</span>
        <span class="tw-font-body tw-text-200">₹0</span>
      </div>
      <div class="tw-border-b tw-border-gray-200 tw-mx-4"></div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-font-bold tw-text-300 tw-text-black" i18n="@@total">Total</span>
        <span class="tw-font-body tw-font-bold tw-text-300">₹{{orderSp}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-p-4" [ngClass]="isRegimenOrder ? 'tw-bg-blue-100' : 'tw-bg-teal-100'">
        <span class="tw-font-body tw-text-300 tw-text-green-500" i18n="@@totalSavings">Total Savings:</span>
        <span class="tw-font-body tw-text-300 tw-text-green-500">₹{{+orderMRP - +orderSp}}</span>
      </div>
    </div>
  </div>
</div>
<pop-up-modal *ngIf="popUpModal.open" [config]="popUpModal" (close)="onPopUpClose($event)"></pop-up-modal>
} @else {
<ng-container *ngTemplateOutlet="regimenOrderTemplate"></ng-container>
}
<ng-template #regimenOrderTemplate>
  <div class="tw-h-full tw-bg-gray-100 tw-font-body tw-overflow-auto" *ngIf="!loading">
    <div class="tw-flex tw-flex-col tw-gap-11 tw-px-4 tw-pt-[18px] tw-pb-4" [ngClass]="bgColor">
      <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <ng-container [ngSwitch]="true">
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourPaymentIsPending" *ngSwitchCase="orderPaymentPendingStages.includes(order.stage )"> Your payment is pending </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsPlaced" *ngSwitchCase="orderPlacedStages.includes(order.stage ) || order.stage  === STAGE.INVOICE_REQUESTED"> Your order is placed </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsPacked" *ngSwitchCase="orderPackedStages.includes(order.stage )"> Your order is packed </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsDispatched" *ngSwitchCase="orderDispatchedStages.includes(order.stage )"> Your order is dispatched </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@deliveryAttemptFailed" *ngSwitchCase="orderDeliveryFailedStages.includes(order.stage )"> Delivery attempt failed </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@orderOutForDelivery" *ngSwitchCase="orderOutForDeliveryStages.includes(order.stage )"> Your order is out for delivery </p>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsDelivered" *ngSwitchCase="orderDeliveredStages.includes(order.stage )"> Your order is Delivered </p>
            <div>
              @if (isOrderInRefundRelatedStages) {
                @switch (latestOrderLog?.stage) {
                  @case (STAGE.REFUND_REQUESTED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black">Your refund is in process</p>
                  }
                  @case (STAGE.REFUND_INITIATED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black">Your refund has been initiated</p>
                  }
                  @case (STAGE.REFUND_PROCESSED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black">Your refund has been processed on {{refundProcessedDate | date: 'd MMM'}}</p>
                  }
                }
              } @else if (orderCanceledStages.includes(order.stage)) {
                @switch (order.stage) {
                  @case (STAGE.RETURN_REQUESTED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourReturnRequestIsInProcess">Your return request is in process</p>
                  }
                  @case (STAGE.RETURN_INITIATED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourReturnHasBeenInitiated">Your return has been initiated</p>
                  }
                  @case (STAGE.RETURNED) {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsReturned">Your order is returned</p>
                  }
                  @default {
                    <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" i18n="@@yourOrderIsCancelled">Your order is Cancelled</p>
                  }
                }
              }
            </div>
            <p class="tw-text-400 tw-font-bold tw-font-body tw-text-black" *ngIf="order.stage  === STAGE.CANCEL_REQUESTED" i18n="@@cancellationRequestInitiated">A cancellation request has been initiated for this order. Click the "Cancel Order" button below to confirm</p>
          </ng-container>
          <p *ngIf="orderNumber" class="tw-text-200 tw-font-medium tw-font-body tw-text-black tw-capitalize"> <span i18n="@@orderNo">Order no:</span> #{{orderNumber}}</p>
          @if (expectedDeliveryDate.from && expectedDeliveryDate.to) {
            <div class="tw-text-200 tw-font-medium tw-font-body tw-text-black" *ngIf="expectedDeliveryDate.from && expectedDeliveryDate.to">
              <div i18n="@@expectedDeliveryDate">
                Expected Delivery Date
              </div>
              <p id="expected-delivery-date">
                {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
              </p>
            </div>
          }
        </div>
        <ng-container [ngSwitch]="true">
          <div class="tw-self-center tw-shrink-0">
            <span (click)="makePaymentForOrder()"
                class="tw-min-w-fit tw-h-max tw-flex tw-justify-center tw-items-center tw-shrink-0 tw-self-end tw-font-bold tw-font-body tw-text-white tw-rounded-xl tw-text-300 tw-overflow-hidden tw-capitalize tw-py-2 tw-px-5 tw-bg-teal-600"
                i18n="@@makePayment"
                *ngSwitchCase="orderPaymentPendingStages.includes(order.stage )">
                Make payment
            </span>

            <div class="tw-self-center"
            *ngSwitchCase="orderPlacedStages.includes(order?.stage ) ||
            orderPackedStages.includes(order?.stage ) ||
            orderDispatchedStages.includes(order?.stage ) ||
            orderDeliveryFailedStages.includes(order?.stage ) ||
            orderOutForDeliveryStages.includes(order?.stage )">
                <span
                  *ngIf="order?.trackingId "
                  (click)='trackOrder(order.trackingURL )'
                  class="tw-min-w-fit tw-h-max tw-flex tw-justify-center tw-items-center tw-shrink-0 tw-self-end tw-font-bold tw-font-body tw-text-white tw-rounded-xl tw-text-300 tw-overflow-hidden tw-capitalize tw-py-2 tw-px-5 tw-bg-teal-600"
                  i18n="@@trackOrder">Track Order</span>
            </div>

            <span (click)="seeInstructions()"
                class="tw-min-w-fit tw-h-max tw-flex tw-justify-center tw-items-center tw-shrink-0 tw-self-end tw-font-bold tw-font-body tw-text-white tw-rounded-xl tw-text-300 tw-overflow-hidden tw-capitalize tw-py-2 tw-px-5 tw-bg-teal-600"
                *ngSwitchCase="orderDeliveredStages.includes(order.stage )"
                i18n="@@seeInstructions">See instructions</span>

            <span (click)="navigateToRegimenPage()"
                class="tw-min-w-fit tw-h-max tw-flex tw-justify-center tw-items-center tw-shrink-0 tw-self-end tw-font-bold tw-font-body tw-text-white tw-rounded-xl tw-text-300 tw-overflow-hidden tw-capitalize tw-py-2 tw-px-5 tw-bg-teal-600"
                i18n="@@reorder"
                *ngSwitchCase="orderCanceledStages.includes(order.stage )">Reorder</span>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="ld-session-block tw-p-4 tw-mt-2 tw-bg-white">
      <p class="tw-text-300 tw-text-black tw-font-bold tw-font-body" i18n="@@deliveryAddress">Delivery Address</p>
      <p class="tw-text-gray-500 tw-text-200 tw-font-normal tw-font-body tw-mt-2">{{order.contactDetail.contactName }}</p>
      <p class="tw-text-gray-500 tw-text-200 tw-font-normal tw-font-body">{{order.contactDetail.buildingDetails }}, {{$any(order.contactDetail)?.localityDetails }} </p>
      <p class="tw-text-gray-500 tw-text-200 tw-font-normal tw-font-body">
        <span *ngIf="$any(order.contactDetail)?.landmark"> {{$any(order.contactDetail).landmark }}, </span>
        <span *ngIf="order.contactDetail?.city"> {{order.contactDetail.city }}, </span>
        <span *ngIf="order.contactDetail?.state"> {{order.contactDetail.state }}, </span>
        <span *ngIf="order.contactDetail?.zipCode"> {{order.contactDetail.zipCode }} </span>
      </p>
      <p *ngIf="!internalUser" class="tw-text-gray-500 tw-text-200 tw-font-normal tw-mt-2 tw-font-body"> +91 {{order.contactDetail.contactNumber }} </p>
    </div>
    <!-- REGIMEN CARD -->
    <div class="tw-px-4 tw-pt-6">
      <div class="tw-p-4 tw-rounded-3 tw-bg-white tw-shadow-z1">
        <div class="tw-flex tw-items-center tw-gap-[5%]" (click)="navigateToRegimenPage()">
          <div class="tw-w-32 tw-min-w-28 tw-h-[120px] tw-rounded-3" [ngClass]="regimenPalette.background100">
            <img [src]="regimen.regimenCoverImage" class="tw-w-32 tw-h-[120px] tw-object-cover tw-rounded-3" alt="regimen_img"/>
          </div>
          <div *ngIf="regimen?.displayConcern?.name" class="tw-flex tw-flex-col tw-gap-2">
            <p class="tw-text-400 tw-font-body tw-font-bold tw-text-black" i18n="@@treatmentKitForConcern">
              Treatment <br/> Kit for <span class="tw-capitalize">{{regimen?.displayConcern?.name}}</span>
            </p>
          </div>
          <div *ngIf="!regimen?.displayConcern?.name">
            <p *ngIf="regimenClassText === appConfig.Shared.RegimenFor.SKIN.toLowerCase()" class="tw-text-400 tw-font-body tw-font-bold tw-text-black"> Treatment <br/> kit for <span class="tw-capitalize"> skin </span> </p>
            <p *ngIf="regimenClassText === appConfig.Shared.RegimenFor.HAIR.toLowerCase()" class="tw-text-400 tw-font-body tw-font-bold tw-text-black"> Treatment <br/> kit for <span class="tw-capitalize"> hair </span> </p>
          </div>
        </div>
        <div *ngIf="showKnowHowToUseProductsCTA" class="tw-flex tw-justify-center tw-items-center tw-my-4 tw-py-1.5 tw-border tw-border-teal-600 tw-border-solid tw-rounded-2" (click)="navigateToRegimenPage()">
          <p class="tw-basis-[75%] tw-text-end tw-text-200 tw-font-bold tw-text-teal-600" i18n="@@KnowHowToUseYourProducts"> Know how to use products </p>
          <div class="tw-basis-[25%] tw-text-center"><cs-icon class="tw-h-2.5 tw-w-2.5 -tw-rotate-90" [iconName]="'arrow_forward'"></cs-icon></div>
        </div>
        <div class="tw-mb-4" [ngClass]="{'tw-mt-2': !showKnowHowToUseProductsCTA}">
          <p class="tw-font-bold tw-text-200 tw-text-black"> <span i18n="@@yourPlanIncludes">Your Plan includes</span>: </p>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1">
            <cs-icon class="tw-w-4 tw-h-4" [iconName]="'rebranding/v1/check'" ></cs-icon>
            <span class="tw-text-200 tw-text-gray-500 tw-font-normal"> {{productsCount}} <span class="tw-lowercase" i18n="@@products">Products</span> </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1.5">
            <cs-icon class="tw-w-4 tw-h-4" [iconName]="'rebranding/v1/check'" ></cs-icon>
            <span class="tw-text-200 tw-text-gray-500 tw-font-normal tw-capitalize" i18n="@@monthlyDoctorCheckup"> Monthly Doctor Checkup </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1.5">
            <cs-icon class="tw-w-4 tw-h-4" [iconName]="'rebranding/v1/check'" ></cs-icon>
            <span class="tw-text-200 tw-text-gray-500 tw-font-normal" i18n="@@dietPlan"> Diet Plan </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1.5">
            <cs-icon class="tw-w-4 tw-h-4" [iconName]="'rebranding/v1/check'"></cs-icon>
            <span class="tw-text-200 tw-text-gray-500 tw-font-normal" i18n="@@dedicatedDoctorForAnyTimeSupport"> Dedicated doctor for any time support </span>
          </div>
          @if (order.moneyBackGuaranteeDetails?.eligible) {
           <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1.5 tw-tracking-none">
            <cs-icon class="tw-w-4 tw-h-4 tw-text-brown-700" [iconName]="'rebranding/v1/check-transparent'"></cs-icon>
            <p class="tw-text-200 tw-leading-[24px] tw-font-bold" (click)="openMoneyBackGuaranteeBottomSheet()">
              <span class="tw-uppercase tw-text-black" i18n="@@money_back">100% Money Back</span>&nbsp;<span class="tw-uppercase tw-text-brown-700" i18n="@@guarantee">guarantee</span>
              <span class="tw-text-gray-500"> - </span>
              <span class="tw-text-teal-600 tw-font-semibold" i18n="@@knowMore">Know More</span>
            </p>
           </div>
          }
        </div>
        <!-- Mini Doctor card -->
        <div *ngIf="!orderCanceledStages.includes(order?.stage ) && doctor" class="tw-py-2 tw-px-4 tw-rounded-full" style="background: linear-gradient(118deg, #FFF6EC 30.34%, #FFF 95.83%);">
          <div class="tw-flex tw-items-center tw-gap-2">
            <img class="tw-w-9 tw-h-9 tw-rounded-full" [src]="doctor.doctorDisplayImage" alt="doctorImage"/>
            <div>
              @if (regimen?.class === appConfig.Shared.Regimen.Class.HAIR) {
                <p class="tw-text-orange-400 tw-text-200 tw-font-bold tw-capitalize" i18n="@@yourHairSpecialist"> Your hair specialist </p>
              } @else {
                <p class="tw-text-orange-400 tw-text-200 tw-font-bold tw-capitalize" i18n="@@yourSkinSpecialist"> Your skin specialist </p>
              }
              <p class="tw-text-black tw-text-200 tw-font-normal"> {{doctor.DoctorDisplayName}} </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Free Products section -->
    <div class="tw-my-2 tw-mx-4" *ngIf="freeProducts.length > 0">
      <p class="tw-w-max tw-m-auto tw-text-200 tw-text-black tw-font-body tw-font-medium"> + </p>
    </div>

    <div class="tw-flex tw-items-center tw-gap-3 tw-mx-4 tw-p-3 tw-border-2 tw-border-dashed tw-border-teal-400 tw-rounded-2 tw-overflow-hidden tw-bg-gradient-white" *ngFor="let freeProduct of freeProducts">
      <div class="tw-relative tw-flex tw-items-center tw-w-20 tw-h-20 tw-px-2.5 tw-rounded-1 tw-bg-[#ebebeb] tw-overflow-hidden">
        <img [src]="freeProduct.imgUrl" alt="freeProductImg"/>
        <div class="tw-w-[60px] tw-absolute -tw-top-[10px] -tw-left-[25px] tw-aspect-video tw-bg-teal-500 -tw-rotate-45"></div>
        <div class="tw-absolute tw-top-1 tw-left-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 10 9" fill="#FEFEFE">
            <path d="M7.11266 0.320901C7.37189 0.179956 7.69269 0.213418 7.85308 0.326807C7.92286 0.37602 7.9907 0.45988 7.91898 0.580355C7.76829 0.834296 7.4475 0.99808 7.10201 0.99808H6.113C6.15951 1.09572 6.1852 1.20163 6.1852 1.31266C6.1852 1.41148 6.16485 1.50636 6.12753 1.59495H8.45297C8.60803 1.35557 8.61917 1.08076 8.48107 0.828782L8.19759 0.311839C8.16464 0.251995 8.11376 0.196092 8.04447 0.147269C7.80412 -0.0224215 7.33893 -0.08856 6.94983 0.123253L5.88184 0.704369C5.94968 0.761457 6.0083 0.82563 6.05531 0.895709L7.11266 0.320901Z" fill="#FEFEFE"/>
            <path d="M4.08957 1.59494C4.05226 1.50636 4.03191 1.41147 4.03191 1.31265C4.03191 1.20162 4.05759 1.09572 4.10411 0.998073H3.11559C2.77008 0.998073 2.4493 0.833896 2.29812 0.579955C2.22641 0.459874 2.29473 0.376016 2.36402 0.3268C2.45028 0.265775 2.58305 0.227978 2.72794 0.227978C2.85199 0.227978 2.98476 0.255932 3.10445 0.320895L4.16178 0.895712C4.20878 0.825631 4.26741 0.761066 4.33525 0.704372L3.26725 0.123255C2.87766 -0.0885654 2.41248 -0.0224168 2.17262 0.147272C2.09557 0.201604 2.04081 0.264602 2.00883 0.332312L1.73602 0.828392C1.59792 1.07997 1.60907 1.35479 1.76413 1.59456H4.08956L4.08957 1.59494Z" fill="#FEFEFE"/>
            <path d="M4.40459 1.59433H5.8128C5.86465 1.50928 5.89421 1.41322 5.89421 1.31203C5.89421 0.960445 5.54143 0.673828 5.10872 0.673828C4.67601 0.673828 4.32324 0.960456 4.32324 1.31203C4.32324 1.41322 4.35274 1.50928 4.40459 1.59433Z" fill="#FEFEFE"/>
            <path d="M0.459961 2.33128V3.11161C0.459961 3.34587 0.66009 3.54312 0.928533 3.59667H4.56616V1.83203H1.07442C0.735698 1.83203 0.459961 2.05608 0.459961 2.33128Z" fill="#FEFEFE"/>
            <path d="M0.928711 7.39115C0.928711 7.75652 1.29456 8.05377 1.74424 8.05377H4.56636V3.83398H0.928736L0.928711 7.39115Z" fill="#FEFEFE"/>
            <path d="M9.14079 1.83203H5.64941V3.59667H9.28655C9.555 3.54312 9.75512 3.34626 9.75512 3.11161V2.33128C9.75512 2.05607 9.47949 1.83203 9.14079 1.83203Z" fill="#FEFEFE"/>
            <path d="M5.64941 8.05339H8.47104C8.92072 8.05339 9.28657 7.75614 9.28657 7.39077V3.83398H5.64944V8.05377L5.64941 8.05339Z" fill="#FEFEFE"/>
          </svg>
        </div>
      </div>
      <div class="tw-h-full">
        <p>{{freeProduct.name}}</p>
        <p class="tw-text-gray-400 tw-text-100 tw-font-medium tw-mt-2">{{freeProduct.quantity}} unit</p>
        <p class="tw-flex tw-items-center"> <span class="tw-text-gray-500 tw-text-200 tw-font-normal tw-line-through"> ₹{{freeProduct.MRP}} </span> <span class="tw-text-500 tw-text-teal-500 tw-font-bold tw-uppercase tw-ml-1" i18n="@@free">free</span> </p>
      </div>
    </div>

    <!-- Order detail  CTA's  -->
    <div class="tw-px-4 tw-py-6">
      <div class="tw-flex tw-flex-col tw-rounded-2.5 tw-overflow-hidden tw-bg-white tw-shadow-z1 tw-py-1 tw-px-4">
        <div class="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-gray-200 last:tw-border-none" *ngIf='$any(order).signedUrlForPdfInvoice' role="button" tabindex="0" (click)='openInvoiceUrl($any(order).signedUrlForPdfInvoice)' (keydown.enter)='openInvoiceUrl($any(order).signedUrlForPdfInvoice)' (keydown.space)='openInvoiceUrl($any(order).signedUrlForPdfInvoice)'>
          <p class="tw-font-body tw-font-bold tw-text-200" i18n="@@downloadInvoice">
            Download Invoice
          </p>
          <cs-icon class="tw-h-6 tw-w-6" [iconName]="'chevron_right_green'"></cs-icon>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-gray-200 last:tw-border-none" *ngIf="regimenApproved" routerLink="/user/prescription">
          <p class="tw-font-body tw-font-bold tw-text-200" i18n="@@seePrescription">
            See Prescription
          </p>
          <cs-icon class="tw-h-6 tw-w-6" [iconName]="'chevron_right_green'"></cs-icon>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-gray-200 last:tw-border-none" routerLink="/support">
          <p class="tw-font-body tw-font-bold tw-text-200">
            <span i18n="@@needHelp">Need help</span><span>?</span>&nbsp;<span i18n="@@chatWithUs">Chat with us</span>
          </p>
          <cs-icon class="tw-h-6 tw-w-6 tw-text-orange-400" [iconName]="'chevron_right_green'"></cs-icon>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-b tw-border-gray-200 last:tw-border-none" *ngIf="cancelOrderAllowed" (click)="cancelOrderDialog()">
          <p class="tw-font-body tw-font-bold tw-text-200 tw-text-orange-500" i18n="@@cancelOrder">Cancel Order</p>
          <cs-icon class="tw-h-6 tw-w-6 tw-text-orange-500" [iconName]="'chevron_right'"></cs-icon>
        </div>
      </div>
    </div>

    <!-- Payment Details -->
    <div class="tw-flex tw-flex-col tw-bg-white tw-pt-2 tw-gap-1.5">
      <h2 class="tw-font-body tw-font-bold tw-text-300 tw-mb-2 tw-px-4" i18n="@@paymentDetails">
        Payment details
      </h2>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@paymentMethod">Payment method</span><span class="tw-font-body tw-text-200">{{order.paymentType.replace('_', ' ') | titlecase}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@subtotalInclusiveTax">Subtotal (inclusive tax)</span><span class="tw-font-body tw-text-200">₹{{orderMRP}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@discount">Discount</span><span class="tw-font-body tw-text-200 tw-text-orange-400">(-) ₹{{+orderMRP - +orderSp}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@shippingCharges">Shipping charges</span><span class="tw-font-body tw-text-200">₹0</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-px-4">
        <span class="tw-font-body tw-font-bold tw-text-300 tw-text-black" i18n="@@total">Total</span><span class="tw-font-body tw-font-bold tw-text-300">₹{{orderSp}}</span>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-blue-100">
        <span class="tw-font-body tw-text-300 tw-text-green-500" i18n="@@totalSavings">Total Savings:</span><span class="tw-font-body tw-text-300 tw-text-green-500">₹{{+orderMRP - +orderSp}}</span>
      </div>
    </div>
  </div>
  <pop-up-modal *ngIf="popUpModal.open" [config]="popUpModal" (close)="onPopUpClose($event)"></pop-up-modal>
</ng-template>
